/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Damages which were reported to the previous insurer.   (german: gemeldete Schäden)   (bipro-produktmodell-versicherung::Vorschaeden)
 */
export interface PreviousDamages {
  /**
   * Number of damages within the previous years.   The number of relevant years is defined in \"numberOfYears\".
   */
  numberOfDamages?: number;
  /**
   * Number of previous years which are considered for damages. Example: “2” for damages within the last two years
   */
  numberOfYears?: number;
}
